import { render, staticRenderFns } from "./SurveyPopup.vue?vue&type=template&id=50254c78&scoped=true&"
import script from "./SurveyPopup.vue?vue&type=script&lang=ts&"
export * from "./SurveyPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyPopup.vue?vue&type=style&index=0&id=50254c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50254c78",
  null
  
)

export default component.exports